import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AxentaCredentials {
  login: string
  password: string
}

interface AxentaState {
  credentials: AxentaCredentials | null
  setCredentials: (credentials: AxentaCredentials) => void
  clearCredentials: () => void
}

export const useAxentaStore = create<AxentaState>()(
  persist(
    (set) => ({
      credentials: null,

      setCredentials: (credentials: AxentaCredentials) => {
        set({ credentials })
      },

      clearCredentials: () => {
        set({ credentials: null })
      },
    }),
    {
      name: 'axenta-storage',
      partialize: (state) => ({
        credentials: state.credentials,
      }),
    }
  )
)
